<template>
  <vue-tel-input
    :id="`tel-input-${id}`"
    :ref="id"
    :modelValue="value"
    @update:modelValue="$emit('update:value', $event)"
    default-country="FR"
    mode="international"
    :preferred-countries="['FR']"
    :disabled="disabled"
    :class="{ 'red-border': valid }"
    :input-options="{
      placeholder: getReferencelabel(placeholder),
    }"
  />
</template>

<script setup>
import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';
import { getReferencelabel } from '@/mixins/utils';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  value: {
    type: [String, Number, null],
    default: null,
  },
  disabled: {
    type: Boolean,
    required: false,
  },
  valid: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(['update:value']);
</script>